import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=3023c562&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023c562",
  null
  
)

component.options.__file = "Join.vue"
export default component.exports